<template>

    <div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

        <label htmlFor="input">
            <b>{{$t(label)}}</b>
            <slot name="label"></slot>
        </label>

        <div class="input-group input-group-radio">
            <template v-for="(option, i) of options" >
                <RadioButton :class="[{ 'p-error' : error }]" :name="option[optionValue]" v-model="model" :value="option[optionValue]" :id="uuid+i" :key="uuid+(i+1)" :disabled="disable"/>
                <label :id="uuid+i" :key="uuid+((i+1)*-1)" :for="option[optionValue]" class="p-radiobutton-label">{{$t(option[optionLabel])}}</label>
            </template>
        </div>
        <span v-if="error">{{ $t(errorMessage)}}</span>

    </div>

</template>

<script>
    import Utils from "@/utils/Utils";
    export default {
        name: "CoffInputRadio",

        props:{
            label: {type: String, default: null},
            value: null,
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            options: {type: Array,
                default() {
                    return [];
                }
            },
            optionLabel: {type: String, default: 'label'},
            optionValue: {type: String, default: 'value'},
            id: null,
            disable: {type: Boolean, default: false}
        },

        watch: {
            value(){
                if(this.model !== this.value){
                    this.model = this.value;
                }
            },
            model(){
                this.$emit('update',this.model);
            }
        },

        data(){
            return {
                uuid: Utils.uuid(),
                model: this.value
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        }
    }
</script>

<style scoped>

    .p-radiobutton-label{
        margin: 0 0.5em 0 0.5em;
    }

    .input-group-radio {
        margin: 0.4em 0 0.5em 0;
    }

</style>
